import { createContext } from 'react';

const SearchResultsContext = createContext({
  // Default values
  searchParams: {},
  referrer: null
});

export default SearchResultsContext;
